<footer
  class="footer"
  [class.footer--logo-bg-white]="branding.footerBackground === 'white'"
  [class.footer--logo-only]="!branding.showBrandText"
  >
  <div class="container">
    <div class="footer-content">
      <div class="footer-brand">
        <div class="footer-logo">
          <div class="logo-icon">
            <img [src]="siteLogoSrc" [alt]="logoAlt" />
          </div>
          @if (branding.showBrandText) {
            <div class="footer-text">
              <h2>{{ branding.programTitle }}</h2>
              <span class="sub-title">{{ branding.programSubtitle }}</span>
              <p class="tagline">
                {{ branding.tagline }}
              </p>
            </div>
          }
        </div>
        <p class="footer-description">
          {{ branding.footerDescription }}
        </p>
      </div>

      <div class="footer-links">
        <div class="footer-section">
          <h3>{{ 'footer.quickLinks' | translate }}</h3>
          <nav aria-label="Footer navigation">
            <ul>
              <li>
                <a routerLink="/about">{{ branding.aboutLinkName }}</a>
              </li>
              <li>
                <a routerLink="/courses">{{ 'footer.courseInformation' | translate }}</a>
              </li>
              <li><a routerLink="/faq">{{ 'footer.faqs' | translate }}</a></li>
              <li>
                <a routerLink="/terms-and-conditions">{{ 'footer.termsAndConditions' | translate }}</a>
              </li>
              <li>
                <a routerLink="/privacy-policy">{{ 'footer.privacyPolicy' | translate }}</a>
              </li>
              <li>
                <a routerLink="/contact">{{ 'footer.technicalSupport' | translate }}</a>
              </li>
            </ul>
          </nav>
        </div>

        <div class="footer-section">
          <h3>{{ 'footer.contactUs' | translate }}</h3>
          <div class="contact-info">
            @if (branding.contactEmail) {
              <div class="contact-item">
                <i class="material-icons" aria-hidden="true">email</i>
                <a
                  [href]="'mailto:' + branding.contactEmail"
                  [attr.aria-label]="('footer.emailUs' | translate) + ' ' + branding.contactEmail"
                >{{ branding.contactEmail }}</a>
              </div>
            }
            @if (branding.contactPhone) {
              <div class="contact-item">
                <i class="material-icons" aria-hidden="true">phone</i>
                <a
                  [href]="phoneHref"
                  [attr.aria-label]="('footer.callUs' | translate) + ' ' + branding.contactPhone"
                >{{ branding.contactPhone }}</a>
              </div>
            }
            @if (addressLines.length) {
              <div class="contact-item">
                <i class="material-icons" aria-hidden="true">location_on</i>
                <div>
                  @for (line of addressLines; track line) {
                    <p>{{ line }}</p>
                  }
                </div>
              </div>
            }
            @if (branding.officeHours) {
              <div class="contact-item">
                <i class="material-icons" aria-hidden="true">schedule</i>
                <span>{{ branding.officeHours }}</span>
              </div>
            }
            @if (branding.contactNote) {
              <div class="contact-item contact-holiday-note">
                <i class="material-icons" aria-hidden="true">info</i>
                <span>{{ branding.contactNote }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
